<template>
  <div class="login-page dot-pattern">
    <div class="login-topbar">
      <RouterLink to="/" class="text-link"><ArrowLeft :size="17" /> 返回首页</RouterLink>
      <span>Magic H5 独立方案 · Preview</span>
    </div>
    <section class="login-shell blur-fade">
      <div class="login-story">
        <BrandMark />
        <span class="pill"><Sparkles :size="14" /> SafetyVision Workspace</span>
        <h1>把每一次学习，<br /><em>变成看得见的进步。</em></h1>
        <p>面向电脑端重新设计的独立 H5 工作台。题库、资料与会员能力共用现有服务端，界面互不影响。</p>
        <div class="login-points">
          <span><Check :size="15" /> 真实后端接口</span>
          <span><Check :size="15" /> 独立构建部署</span>
          <span><Check :size="15" /> 原 H5 保持不变</span>
        </div>
      </div>
      <form class="login-card border-beam-card" @submit.prevent="submit">
        <div class="login-card-head">
          <span>欢迎回来</span>
          <h2>登录你的学习空间</h2>
          <p>本地验收可使用已有全权限测试账号</p>
        </div>
        <label>
          <span>邮箱或账号</span>
          <div class="input-wrap"><Mail :size="18" /><input v-model.trim="account" autocomplete="username" placeholder="请输入邮箱或账号" /></div>
        </label>
        <label>
          <span>密码</span>
          <div class="input-wrap"><LockKeyhole :size="18" /><input v-model="password" :type="showPassword ? 'text' : 'password'" autocomplete="current-password" placeholder="请输入密码" /><button type="button" @click="showPassword = !showPassword"><Eye v-if="!showPassword" :size="18" /><EyeOff v-else :size="18" /></button></div>
        </label>
        <label class="agreement"><input v-model="agreed" type="checkbox" /> <span>我已阅读并同意《用户协议》和《隐私政策》</span></label>
        <div v-if="error" class="form-error"><CircleAlert :size="16" />{{ error }}</div>
        <button class="shimmer-button" :disabled="submitting" type="submit">
          <LoaderCircle v-if="submitting" class="spin" :size="18" />
          <LogIn v-else :size="18" />
          {{ submitting ? "正在验证…" : "进入工作台" }}
        </button>
        <div class="demo-account">
          <span>本地全权限账号</span>
          <button type="button" @click="fillDemo">fullaccess@zhizhi.local <Copy :size="13" /></button>
        </div>
      </form>
    </section>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ArrowLeft, Check, CircleAlert, Copy, Eye, EyeOff, LoaderCircle, LockKeyhole, LogIn, Mail, Sparkles } from "lucide-vue-next";
import BrandMark from "../components/BrandMark.vue";
import { api, setSession } from "../services/api";

const route = useRoute();
const router = useRouter();
const account = ref("fullaccess@zhizhi.local");
const password = ref("Demo123456");
const agreed = ref(true);
const showPassword = ref(false);
const submitting = ref(false);
const error = ref("");

function fillDemo() {
  account.value = "fullaccess@zhizhi.local";
  password.value = "Demo123456";
}

async function submit() {
  error.value = "";
  if (!account.value || !password.value) return void (error.value = "请输入账号和密码。");
  if (!agreed.value) return void (error.value = "请先同意用户协议和隐私政策。");
  submitting.value = true;
  try {
    const response = await api.login(account.value, password.value);
    if (response?.code !== 200 || !response?.data?.token) throw new Error(response?.message || "登录失败");
    setSession(response.data.token, response.data.userInfo || { account: account.value });
    await router.replace(String(route.query.redirect || "/"));
  } catch (e) {
    error.value = e?.message || "登录失败，请检查服务状态。";
  } finally {
    submitting.value = false;
  }
}
</script>
